// Client-side interpretation of the server's pre-dial compliance responses.
export const GUARD_CODES = Object.freeze({
  QUIET_HOURS: 'TCPA_QUIET_HOURS',
  FREQUENCY_CAP: 'CALL_FREQUENCY_CAP',
  AGREEMENT: 'PRODUCER_AGREEMENT_REQUIRED',
});

export const CALLING_HOURS_LABEL = '8:00 AM – 8:00 PM';

/**
 * Map an axios error from /phone/click-to-call to a guard prompt.
 * @param {*} err
 * @returns {{kind: 'quiet'|'frequency'|'agreement', info: object}|null} null for non-guard errors.
 */
export function interpretGuardError(err) {
  const status = err?.response?.status;
  const d = err?.response?.data || {};
  if (status === 409 && d.code === GUARD_CODES.QUIET_HOURS) return { kind: 'quiet', info: d.quietHours || {} };
  if (status === 409 && d.code === GUARD_CODES.FREQUENCY_CAP) return { kind: 'frequency', info: d.frequency || {} };
  if (status === 403 && d.code === GUARD_CODES.AGREEMENT) return { kind: 'agreement', info: d };
  return null;
}

/** @param {{localTime?: string, zoneAbbr?: string}} info @returns {string} The modal's warning sentence. */
export function quietHoursMessage(info = {}) {
  return `This contact's local time is ${info.localTime || '--'} (${info.zoneAbbr || 'local'}), which is outside standard calling hours (${CALLING_HOURS_LABEL}).`;
}

/** @param {{state?: string}} twoParty @returns {string} The in-call two-party consent banner text. */
export function twoPartyMessage(twoParty = {}) {
  return `Dual-Consent State (${twoParty.state || '--'}): Legally inform the contact: "This call is recorded for quality and compliance purposes." before proceeding.`;
}
